module.exports = __webpack_public_path__ + "img/subir-modelo-exotics-thumb.9d7761a2.png";